/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Support_TeamInputs */

const en_inbox_support_team = /** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC Support Team`)
};

const es_inbox_support_team = /** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo de Soporte de SSC`)
};

const fr_inbox_support_team = /** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe de support SSC`)
};

const de_inbox_support_team = /** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC-Support-Team`)
};

const id_inbox_support_team = /** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim Dukungan SSC`)
};

/** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */
const ja_inbox_support_team = en_inbox_support_team;

/** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */
const zh_inbox_support_team = en_inbox_support_team;

/** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */
const ar_inbox_support_team = en_inbox_support_team;

/** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */
const it_inbox_support_team = en_inbox_support_team;

/** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */
const ru_inbox_support_team = en_inbox_support_team;

/** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */
const pt_inbox_support_team = en_inbox_support_team;

/** @type {(inputs: Inbox_Support_TeamInputs) => LocalizedString} */
const ko_inbox_support_team = en_inbox_support_team;

/**
* | output |
* | --- |
* | "SSC Support Team" |
*
* @param {Inbox_Support_TeamInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_support_team = /** @type {((inputs?: Inbox_Support_TeamInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Support_TeamInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_support_team(inputs)
	if (locale === "es") return es_inbox_support_team(inputs)
	if (locale === "fr") return fr_inbox_support_team(inputs)
	if (locale === "de") return de_inbox_support_team(inputs)
	if (locale === "ja") return ja_inbox_support_team(inputs)
	if (locale === "zh") return zh_inbox_support_team(inputs)
	if (locale === "ar") return ar_inbox_support_team(inputs)
	if (locale === "id") return id_inbox_support_team(inputs)
	if (locale === "it") return it_inbox_support_team(inputs)
	if (locale === "ru") return ru_inbox_support_team(inputs)
	if (locale === "pt") return pt_inbox_support_team(inputs)
	return ko_inbox_support_team(inputs)
});